// import React from "react";
// import { BoxLoading } from "react-loadingg";
// const Container = () => <BoxLoading />;
// export default Container;

import React, { Component } from "react";
import { SemipolarLoading } from "react-loadingg";
class Container extends Component {
  render() {
    return <SemipolarLoading color="#00FFFF" />;
  }
}
export default Container;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js